import React, { useEffect, useState } from 'react';
import { FaTimes } from 'react-icons/fa'
import _ from 'lodash';

type Props = {
  onGenerateClick: (event: React.UIEvent,
    tags: string[]) => void,
    keywords: string[]
  }
  
const MultiTagSelector = ({ onGenerateClick, keywords }: Props) => {
  const [tags, setTags] = useState<string[]>([]);
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    setTags(keywords)
  }, [keywords])

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  const focusOnInput = () => {
    const inputElement = document.querySelector<HTMLInputElement>(".keywordInput");
    inputElement?.focus();
  }

  const handleInputKeyUp = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const newValue = inputValue.replaceAll("-", "").trim();
    
    if ((e.key === ' ' || e.key === '-') && newValue !== '') {
      if (!_.includes(tags, newValue)) {
        setTags([...tags, newValue]);
      }
      setInputValue('');
    }
    let temp = [...tags]
    if (e.key === 'Backspace' && inputValue.trim() === '') {
      temp.splice(temp.length - 1, 1)
      setTags(temp);
    }
    if (e.key === 'Enter') {
      if (!_.includes(tags, newValue) && newValue !== "") {
        setTags([...tags, newValue]);
        onGenerateClick(e, [...tags, newValue])
      } else {
        onGenerateClick(e, tags)
      }
      setInputValue('');
    }
  };

  const handleGenerateBtnClick = (event: React.UIEvent) => {
    const newValue = inputValue.trim();
    if (!_.includes(tags, newValue) && newValue !== "") {
      setTags([...tags, newValue]);
      onGenerateClick(event, [...tags, newValue])
    } else {
      onGenerateClick(event, tags)
    }
    setInputValue('');
  }

  const handleTagRemove = (tag: string) => {
    const updatedTags = tags.filter((t) => t !== tag);
    setTags(updatedTags);
  };

  return (
    <div className={"keywordsWrapper"} onClick={focusOnInput}>
      <span className={"tagsWrapper"}>
        {tags.map((tag, index) => (
          <span key={index} className={"tagWrapper"} onClick={() => handleTagRemove(tag)}>
            <span>{tag}</span>
            <span className="close-icon"><FaTimes /></span>
          </span>
        ))}
        <input
          type="text"
          className={"keywordInput"}
          value={inputValue}
          onChange={handleInputChange}
          onKeyUp={handleInputKeyUp}
          placeholder="Add a keyword"
        />
      </span>
      <button
        onClick={handleGenerateBtnClick}
        className={"generateWrapper"}
      >
        <span>Generate</span>
      </button>
    </div>
  );
};

export default MultiTagSelector;
